import { FC } from "react";
import { IBundle, LanguageKeys, VehicleType } from "../../entities/interface";
import styles from "./styles.module.css";
import classNames from "classnames";

interface IServiceBoxProps {
  bundle: IBundle;
  locationId: number;
  lng?: LanguageKeys;
  bundleId?: number | null;
}

export const BundleBox: FC<IServiceBoxProps> = (props) => {
  const { bundle, lng, locationId, bundleId } = props;
  return (
    <div
      className={classNames(styles.bundleBoxContainer, {
        [styles.hightLighted]: bundle.id === Number(bundleId),
      })}
    >
      <h3 className={styles.bundleBoxTitle}>
        {lng === LanguageKeys.Swedish ? bundle?.name.sw : bundle?.name.en}
      </h3>
      {bundle?.content.length && (
        <ul className={styles.contentContainer}>
          {bundle?.content?.map((b) => {
            return (
              <li key={b?.id}>
                <p>
                  {lng === LanguageKeys.Swedish ? b.name?.sw : b.name?.en}{" "}
                  {lng === LanguageKeys.Swedish
                    ? `(${b.qty} st)`
                    : `(${b.qty} pcs)`}
                </p>
              </li>
            );
          })}
        </ul>
      )}
      <div className={styles.bundleBoxPrice}>
        <p>{bundle?.priceWithVat ? bundle?.priceWithVat / 100 : "-"}:- /</p>
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://booking.mydrivingacademy.com/widget?vehicleType=${
            bundle.vehicleType ? bundle.vehicleType : VehicleType.Car
          }&productType=Bundle&serviceId=${bundle.id}&regionId=${
            bundle.regionId
          }&locationId=${locationId}`}
        >
          {lng === LanguageKeys.Swedish ? "Boka nu" : "Buy now"}
        </a>
      </div>
    </div>
  );
};
